import toast, { ToastOptions } from 'react-hot-toast';

interface ToastMessage {
  title?: string;
  message: string;
}

const Toast = (msg: string | undefined | ToastMessage, isError = false) => {
  const toastOptions: ToastOptions = {};

  const customToastStyle = {
    backgroundColor: '#fff',
    padding: '16px 24px',
    borderRadius: '12px',
    boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
    color: '#000',
    maxWidth: '380px',
    width: '100%',
    display: 'flex',
    justifyContent: 'flex-start',
  };

  const renderContent = (content: string | undefined | ToastMessage) => {
    if (!content) {
      return '';
    }
    if (typeof content === 'string') {
      return content;
    }
    return (
      <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
        {content.title && (
          <span
            style={{
              fontWeight: '600',
              fontSize: '18px',
              lineHeight: '1.2',
            }}
          >
            {content.title}
          </span>
        )}
        <span
          style={{
            fontSize: '15px',
            lineHeight: '1.4',
            color: '#1a1a1a',
          }}
        >
          {content.message}
        </span>
      </div>
    );
  };

  if (typeof msg === 'string') {
    if (isError) {
      toast.error(renderContent(msg), toastOptions);
    } else {
      toast.success(renderContent(msg), toastOptions);
    }
  } else {
    toast(renderContent(msg), { ...toastOptions, icon: null, style: customToastStyle });
  }
};

export { Toast };
